import React from "react";

const images = [
  {
    src: "/gallery/bmw_front.jpg",
    alt: "BMW X5 front grille — gloss finish after detail",
    span: "lg:col-span-7",
    aspect: "aspect-[7/5]",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_showroom-finish-auto/artifacts/6bvem3o7_IMG_5554.jpeg",
    alt: "BMW X5 rear seats — diamond stitched leather under panoramic roof",
    span: "lg:col-span-5",
    aspect: "aspect-[1/1]",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_showroom-finish-auto/artifacts/q2heq5u8_IMG_5559.jpeg",
    alt: "BMW X5 engine bay — fully detailed",
    span: "lg:col-span-4",
    aspect: "aspect-[3/4]",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_showroom-finish-auto/artifacts/rhujqeqa_IMG_5557.jpeg",
    alt: "BMW X5 driver cockpit — alcantara wheel and curved display",
    span: "lg:col-span-4",
    aspect: "aspect-[3/4]",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_showroom-finish-auto/artifacts/opui5k0t_IMG_5556.jpeg",
    alt: "BMW X5 dashboard side view — crystal-clear glossy finish",
    span: "lg:col-span-4",
    aspect: "aspect-[3/4]",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_showroom-finish-auto/artifacts/jaqs9n65_IMG_5543.jpeg",
    alt: "BMW X5 side profile — paint reflection",
    span: "lg:col-span-5",
    aspect: "aspect-[1/1]",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_showroom-finish-auto/artifacts/4kd0fh45_IMG_5545.jpeg",
    alt: "BMW X5 wheel and front quarter — showroom finish",
    span: "lg:col-span-7",
    aspect: "aspect-[7/5]",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_showroom-finish-auto/artifacts/jf7vrzu9_IMG_5549.jpeg",
    alt: "BMW X5 boot space — fully detailed",
    span: "lg:col-span-6",
    aspect: "aspect-[4/3]",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_showroom-finish-auto/artifacts/gfq10jzi_IMG_5546.jpeg",
    alt: "BMW X5 spare tyre compartment — cleaned",
    span: "lg:col-span-6",
    aspect: "aspect-[4/3]",
  },
];

export default function Gallery() {
  return (
    <section
      id="gallery"
      data-testid="gallery-section"
      className="section bg-[color:var(--bg)]"
    >
      <div className="max-w-[1400px] mx-auto">
        <div className="flex flex-col gap-6 lg:grid lg:grid-cols-12 lg:items-end mb-10">
          <div className="col-span-12 lg:col-span-8">
            <div className="flex items-center gap-3 mb-6 reveal">
              <span className="diamond-divider" />
              <span className="overline">Selected Work</span>
            </div>
            <h2 className="reveal font-display tracking-tight text-neutral-900 text-4xl md:text-5xl">
              The Diamond
              <span className="text-neutral-500 font-light italic"> finish.</span>
            </h2>
          </div>
          <div className="col-span-12 lg:col-span-4 reveal">
            <p className="text-neutral-500 text-sm leading-relaxed">
              A small selection of recent details performed on-site for
              clients across performance, luxury and daily drivers.
            </p>
          </div>
        </div>

        <div className="flex flex-col gap-4 sm:grid sm:grid-cols-12 lg:gap-5">
          {images.map((img, i) => (
            <figure
              key={img.src}
              data-testid={`gallery-item-${i}`}
              className={`col-span-12 sm:col-span-6 ${img.span} relative overflow-hidden border border-neutral-100 group reveal`}
            >
              <div className={img.aspect}>
                <img
                  src={img.src}
                  alt={img.alt}
                  className="w-full h-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-110"
                  loading="lazy"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/55 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
